import { render, staticRenderFns } from "./ProcessListPage.vue?vue&type=template&id=b6ed725c&scoped=true"
import script from "./ProcessListPage.vue?vue&type=script&lang=js"
export * from "./ProcessListPage.vue?vue&type=script&lang=js"
import style0 from "./ProcessListPage.vue?vue&type=style&index=0&id=b6ed725c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ed725c",
  null
  
)

export default component.exports